import ArchiveModal from './ArchiveModal';

export default ArchiveModal;
export * from './styles';
